import React, { useRef, useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { base_url_clean } from '../../../config/urls';
import './css/CircleOverlay.css';

const CircleOverlay = ({ onCircleCreated, disabled, imagen, circles = [], onCirclesChange }) => {
    const containerRef = useRef(null);
    const [imageLoaded, setImageLoaded] = useState(false);

    const handleClick = (e) => {
        if (disabled || !imageLoaded) return;

        const rect = containerRef.current.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width;
        const y = (e.clientY - rect.top) / rect.height;

        const newCircle = {
            x,
            y,
            label: "!",
        };

        onCircleCreated?.({ x: newCircle.x, y: newCircle.y });

        onCirclesChange?.([...circles, newCircle]);
    };

    const imageSrc = imagen ? `${base_url_clean}img/temas${imagen}` : null;

    return (
        <Box sx={{ width: 'fit-content', margin: 'auto', border: '1px solid black', mt: 4, cursor: 'crosshair' }}>
            <div ref={containerRef} className="image-wrapper" onClick={handleClick}>
                {imagen && (
                    <img
                        src={imageSrc}
                        alt="tema"
                        className="image"
                        onLoad={() => setImageLoaded(true)}
                        onError={() => setImageLoaded(false)}
                    />
                )}

                {circles.map((circle, i) => (
                    <div
                        key={i}
                        className="circle"
                        style={{
                            left: `${circle.x * 100}%`,
                            top: `${circle.y * 100}%`,
                        }}
                    >
                        <span className="circle-label">{circle.label}</span>
                    </div>
                ))}
            </div>

            {!imageLoaded && (
                <Typography variant="body2" color="error" align="center">
                    Seleccione un Tema.
                </Typography>
            )}
        </Box>
    );
};

export default CircleOverlay;